import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { UntilDestroy } from '@ngneat/until-destroy';

import {
    AlertService,
    ButtonColors,
    ButtonModule,
    LayerService,
    TextfieldModule,
} from '@ed---interne/ng-uui-components';
import { createOrganization } from '../../../../features/admin/organization/organization.state';
import { Organization } from '../../../../core/models/organization.model';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

export interface ElementClickData {
    object: any;
    objectKey: string;
    event?: any;
}

@UntilDestroy()
@Component({
    selector: 'organization-create',
    templateUrl: './organization-create.component.html',
    styleUrls: ['./organization-create.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        NgxTippyModule,
        ButtonModule,
        TextfieldModule,
    ],
})
export class OrganizationCreateComponent {
    public buttonColors = ButtonColors;

    public password: string | null = null;
    public passwordConfirm: string | null = null;
    public header: any;
    public orgaFormGroup: FormGroup = this.formBuilder.group({
        name: [''],
    });

    @Output()
    public onElementClick = new EventEmitter<ElementClickData>();

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly layerService: LayerService,
        private readonly store: Store,
        private readonly alertService: AlertService,
    ) {
        this.orgaFormGroup = this.formBuilder.group({
            name: [''],
        });
    }

    public valid(): void {
        const { name } = this.orgaFormGroup.value;
        const orgaToUpdate: Partial<Organization> = {
            name: name,
        };
        //create
        this.store.dispatch(new createOrganization({ organizationPart: orgaToUpdate })).subscribe({
            next: () => {
                this.alertService.valid('Organsiations', 'Organisation créée !');
                this.close();
            },
            error: (err) => {
                console.log(err);
                this.alertService.error('Création', `une erreur est survenue : ${err?.error?.msg}`);
            },
        });
    }

    isMail(input: string): boolean {
        const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return expression.test(input);
    }

    public set params(params: { header: any }) {}

    public close(): void {
        this.layerService.close();
    }

    public canCreateEdit(): boolean {
        return this.orgaFormGroup.invalid || !this.orgaFormGroup.dirty;
    }

    public elementClicked(object: object, objectKey: string, event?: any): void {
        this.onElementClick.emit({ object, objectKey, event });
    }

    public onFileSelect(event: any): void {
        console.log(event);
    }
    public showPopupOnLayerClose(): boolean {
        return this.orgaFormGroup.dirty;
    }
}
